var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ContentSettingsEditor',{attrs:{"edit-type":_vm.editType,"code":_vm.code}})
}
var staticRenderFns = []

export { render, staticRenderFns }